import {combineReducers} from 'redux';

import {VisibilitySliceFor} from '../../../store/VisibilitySliceFor';
import {SelectionSliceFor} from '../../../store/SelectionSliceFor';

const entityKey = 'messages';

const visibilitySlice = VisibilitySliceFor(entityKey);
const selectionSlice = SelectionSliceFor(entityKey);

export const {
    setPage,
    incrementPage,
    decrementPage,
    setPageSize,
    resetPageSize,
    setKeyword,
    clearKeyword,
    show,
    hide,
    toggleVisibility,
    setTableColumns,
    addTableColumn,
} = visibilitySlice.actions;

export const {
    addToSelection,
    removeFromSelection,
    clearSelection,
} =
    selectionSlice.actions;

export const MessagesReducer = // FNP-950: the `records` sub-reducer is gone - records live in React Query.
combineReducers({
                                                   
                                                   selection: selectionSlice.reducer,
                                                   visibility: visibilitySlice.reducer,
                                               });

